import useSWR from 'swr';

import { fetchPreferences, type Preferences } from '../data/preferencesRepository.js';

export const PREFERENCES_KEY = 'preferences/self';

export type PreferencesState =
  | { status: 'loading' }
  | { status: 'error'; message: string; retry: () => void }
  | { status: 'ready'; preferences: Preferences; refresh: () => Promise<unknown> };

export function usePreferences(): PreferencesState {
  const { data, error, isLoading, mutate } = useSWR<Preferences, Error>(
    PREFERENCES_KEY,
    fetchPreferences,
    { revalidateOnFocus: false, shouldRetryOnError: false },
  );

  if (error) {
    return {
      status: 'error',
      message: error.message || 'Không tải được tuỳ chọn cá nhân.',
      retry: () => {
        void mutate();
      },
    };
  }

  if (isLoading || !data) return { status: 'loading' };

  return { status: 'ready', preferences: data, refresh: () => mutate() };
}
